import { Heading, Link, List, Paragraph } from "@digdir/designsystemet-react";
import { ExternalLinkIcon } from "@navikt/aksel-icons";
import { useTranslation } from "react-i18next";
import {
  BestillingNavigationActions,
  useBestillingNavigation,
} from "@/features/navigation";
import type { BestillingPageKey } from "../config";
import { FormPage } from "./FormPage";

const currentPageKey: BestillingPageKey = "/bestilling/ny/informasjon";

export const InformasjonOmNorgesprisPage = () => {
  const { navigateNext } = useBestillingNavigation(currentPageKey);
  const { t } = useTranslation();

  const handleSubmit = async () => {
    await navigateNext();
  };

  return (
    <FormPage>
      <Heading data-size="lg" level={1}>
        {t("pages.informasjon-om-norgespris.tittel")}
      </Heading>
      <form action={handleSubmit} className="space-y-9">
        <Paragraph data-size="xl">
          {t("pages.informasjon-om-norgespris.liste.tittel")}
        </Paragraph>
        <List.Unordered>
          <List.Item>
            {t("pages.informasjon-om-norgespris.liste.punkt-0")}
          </List.Item>
          <List.Item>
            {t("pages.informasjon-om-norgespris.liste.punkt-1")}
          </List.Item>
          <List.Item>
            {t("pages.informasjon-om-norgespris.liste.punkt-2")}
          </List.Item>
          <List.Item>
            {t("pages.informasjon-om-norgespris.liste.punkt-3")}
          </List.Item>
          <List.Item>
            {t("pages.informasjon-om-norgespris.liste.punkt-4")}
          </List.Item>
          <List.Item>
            {t("pages.informasjon-om-norgespris.liste.punkt-5")}
          </List.Item>
          <List.Item>
            {t("pages.informasjon-om-norgespris.liste.punkt-6")}
          </List.Item>
        </List.Unordered>
        <div className="flex items-center gap-2">
          <Link
            target="_blank"
            rel="noreferrer"
            href={t("eksterneLenker.merOmNorgespris.url")}
          >
            {t("eksterneLenker.merOmNorgespris.label")}
          </Link>
          <ExternalLinkIcon fontSize={"1.5rem"} className="pl-1" />
        </div>
        <BestillingNavigationActions
          currentPageKey={currentPageKey}
          disableNext={false}
        />
      </form>
    </FormPage>
  );
};
